import { StoreState } from 'app/state/types'
import { EmptyObject, ShoppingCart } from 'app/types/common-types'

interface State extends StoreState {
    cart?: ShoppingCart | EmptyObject
}

export default function getDuties(state: State) {
    const { cart } = state
    const { x_dduAcceptance, x_deliveryDuty } = cart || {}

    return {
        deliveryDuty: x_deliveryDuty,
        dduAcceptance: x_dduAcceptance,
    }
}
